const IS_BOT_BY_CAMPAIGN_COOKIE_KEY = 'is_bot_by_campaign';

/** Определяет, бот это или нет */
export function getCanRunAds(): boolean {
  if (window._cianCanRunAds === false) {
    return false;
  }

  let isBot = doesCookieExist(IS_BOT_BY_CAMPAIGN_COOKIE_KEY);

  if (!isBot) {
    const urlParams = new URLSearchParams(window.location.search);
    const utmCampaign = urlParams.get('utm_campaign');

    // Признак бота по utm_campaign: боты Яндекса ходят с utm_campaign не длиннее 9 символов и только из цифр
    if (!!utmCampaign && utmCampaign.length <= 9 && /^[0-9]+$/.test(utmCampaign)) {
      isBot = true;
    }
  }

  return !isBot;
}

function doesCookieExist(cookieName: string): boolean {
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();

    if (cookie.startsWith(`${cookieName}=`)) {
      return true;
    }
  }

  return false;
}
